import type { ReactElement } from "react";

interface ArrowIconProps {
  size?: number;
}

export const ArrowIcon = ({ size = 18 }: ArrowIconProps): ReactElement => (
  <svg aria-hidden="true" fill="none" height={size} viewBox="0 0 20 20" width={size}>
    <path d="M2.5 10h14M11.5 4.8 16.7 10l-5.2 5.2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
  </svg>
);
